import { useCallback, useMemo } from 'react';

import { create, show, useModal } from '@ebay/nice-modal-react';

import AddToTeamDialog, { type AddToTeamProps } from 'components/dialogs/addToTeamDialog/AddToTeamDialog';
import useMutateTournament from 'hooks/tournament/useMutateTournament';
import type { ParticipantInterface } from 'typedefs/store/tmxTypes';

const Modal = create(
  ({ selectedPlayers, onAddToTeam, loading, eventId, showAllTeams, onResetRowSelection }: AddToTeamProps) => {
    const modal = useModal();

    return (
      <AddToTeamDialog
        eventId={eventId}
        loading={loading}
        open={modal.visible || loading}
        selectedPlayers={selectedPlayers}
        showAllTeams={showAllTeams}
        onAddToTeam={onAddToTeam}
        onClose={modal.hide}
        onExited={modal.remove}
        onResetRowSelection={onResetRowSelection}
      />
    );
  },
);

export const useAddToTeamDialog = () => {
  const [addPlayerToTeam, isSaving] = useMutateTournament('addPlayerToTeam');

  const handleShow = useCallback(
    (
      selectedPlayers: ParticipantInterface[],
      showAllTeams = false,
      eventId?: string,
      onResetRowSelection?: () => void,
    ) => {
      return show(Modal, {
        loading: isSaving,
        selectedPlayers,
        onAddToTeam: addPlayerToTeam,
        eventId,
        showAllTeams,
        onResetRowSelection,
      } as AddToTeamProps);
    },
    [addPlayerToTeam, isSaving],
  );

  return useMemo(() => handleShow, [handleShow]);
};
